import type { FC, ReactNode } from 'react'
import type { Categoria } from '@/types'

import Container from '@/components/generals/container'
import SectionHeading from '@/components/generals/section-heading'
import CategoryCard from '@/components/catalog/category-card'

interface CategoriesSectionProps {
    categorias: Array<Categoria>
}

const CategoriesSection: FC<CategoriesSectionProps> = ({ categorias }): ReactNode => {
    return (
        <section id='categorias' aria-labelledby='categorias-titulo' className='bg-black py-24 md:py-32'>
            <Container>
                <div className='flex flex-col gap-8 lg:flex-row lg:items-end lg:justify-between'>
                    <SectionHeading
                        id='categorias-titulo'
                        eyebrow='Categorías'
                        title='Un reconocimiento para cada logro.'
                    />

                    <p className='max-w-md text-base leading-relaxed text-muted-foreground'>
                        Cuatro líneas de producto pensadas para empresas, instituciones, centros educativos, organizaciones deportivas y celebraciones personales.
                    </p>
                </div>

                {categorias.length > 0 ? (
                    <div className='mt-14 grid gap-5 sm:grid-cols-2 lg:grid-cols-4'>
                        {categorias.map(categoria => (
                            <div key={categoria.id} className='reveal'>
                                <CategoryCard categoria={categoria} />
                            </div>
                        ))}
                    </div>
                ) : (
                    <p className='mt-14 rounded-sm border border-dashed border-ivory/15 px-6 py-12 text-center text-muted-foreground'>
                        Las categorías del catálogo se mostrarán aquí en cuanto estén publicadas.
                    </p>
                )}
            </Container>
        </section>
    )
}

export default CategoriesSection
